var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-warp"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/images/login/logo.png"),"alt":""}}),_c('div',{staticClass:"code-box"},[_c('div',{staticClass:"title"},[_vm._v("A.O.史密斯企业微信登录")]),_c('div',{staticClass:"code",attrs:{"id":"code_img"}})])])
}]

export { render, staticRenderFns }